<div class="container" *ngIf="searchMode">
    <form [formGroup]="firstFormGroup">
        <div class="view-component-title">
            <div class="title">{{'meli.wizard.title'|translateTA}}</div>
        </div>

        <div class="step-container" *ngIf="!showCatalogoProducts">
            <div class="tem-field" *ngIf="us.user.companylist.length > 0">
                <span class="tem-field-label">{{'meli.wizard.chooseCompany'|translateTA}}</span>
                <nz-select [(ngModel)]="codeCompany" [ngModelOptions]="{standalone: true}" nzShowSearch
                    [nzPlaceHolder]="'meli.wizard.chooseCompany'|translateTA">
                    <nz-option *ngFor="let data of us.user.companylist" [nzValue]="data.codecompany"
                        [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
                </nz-select>
            </div>

            <div class="tem-field">
                <span class="tem-field-label">{{'meli.wizard.search'|translateTA}}</span>
                <nz-input-group nzSearch [nzAddOnAfter]="searchButton">
                    <input nz-input formControlName="searchCatalogo"
                        [placeholder]="'meli.wizard.searchPlaceholder'|translateTA"
                        (keydown.enter)="buscaProduto(); $event.preventDefault()" />
                </nz-input-group>
                <ng-template #searchButton>
                    <button nz-button nzType="primary" nzSearch (click)="buscaProduto()"
                        [attr.aria-label]="'meli.wizard.searchTooltip'|translateTA">
                        <nz-icon nzType="search" />
                    </button>
                </ng-template>
            </div>
        </div>

        <div class="action">
            <button nz-button nzType="link" (click)="novoAnuncio()">{{'meli.wizard.newProduct'|translateTA}}</button>
            <span class="spacer"></span>
            <button *ngIf="showCatalogoProducts" nz-button nzShape="circle" nz-tooltip
                [nzTooltipTitle]="'meli.wizard.backToSearch'|translateTA"
                (click)="showCatalogoProducts=!showCatalogoProducts">
                <nz-icon nzType="rollback" />
            </button>
        </div>

        <nz-divider class="wizard-divider"></nz-divider>

        <div class="step-container-card-product" *ngIf="showCatalogoProducts">
            <nz-empty *ngIf="produtosCatalogo.length === 0" [nzNotFoundContent]="'meli.wizard.noResults'|translateTA"></nz-empty>
            <div class="data-catalogo-item">
                <item-meli-catalogo-card *ngFor="let produtos of produtosCatalogo" [data]="produtos"
                    [product_identifier] (submitted)="getSelecionado($event)" [codeCompany]="codeCompany"></item-meli-catalogo-card>
            </div>
        </div>
    </form>
</div>

<div *ngIf="!searchMode" class="container-dados-edit">
    <meli-edit-form [data]="data" (saving)="salvandoPrincipal($event)" *ngIf="oldMeli"></meli-edit-form>
    <editform *ngIf="!oldMeli"
        [parentRow]="parentRow"
        [entityName]="entityName"
        [entityDesc]="entityDesc"
        [row]="row"
        [filter]="filter"
        [userConfig]="userConfig"
        [tableInformation]="tableInformation"
        [formViewColumns]="formViewColumns"
        [formGroup]="formGroup"
        [evento]="evento"
        [forceParentRow]="forceParentRow"
        [$$REFERENCES]="$$REFERENCES"
        [actionList]="actionList"
        (saving)="salvandoPrincipal($event)"
        [canConfig]="canConfig"
        [dataMultiTableConfig]="dataMultiTableConfig">
    </editform>
</div>
